<div class="info-dialog-wrapper">
    <div class="info-dialog-header">
        <h2> Spin n Win Offer <br>Terms & Conditions</h2>
        <div class="divider"></div>
    </div>

    <div class="info-dialog-body">
        <ol class="terms-list">
            <li><b>Eligibility:</b><br />Sign up to participate in the "Spin n Win" offer.</li>
            <li><b>Participation:</b><br />Check our website for ongoing "Spin n Win" offers and spin to win prizes.
            </li>
            <li><b>Product Selection:</b><br />Spin any product displayed on the "Spin n Win" page.</li>
            <li><b>Prize Selection:</b><br />Choose to avail either a free product or cash discount.</li>
            <li><b>Daily Limit:</b><br />Maximum 5 products can be availed under "Spin n Win" per day.</li>
            <li><b>Multiple Offers:</b><br />Multiple offers may be available simultaneously.</li>
        </ol>
        <p class="footer-text">By participating, you agree to these terms and conditions.</p>
    </div>

    <!-- Bottom right close button -->
    <div class="floating-cancel-btn">
        <button type="button" class="closse_btn" (click)="close(false)" aria-label="Action">
            <i class="fa fa-close"></i>
        </button>
    </div>
</div>